import PropTypes from 'prop-types'

import CheckboxField from '../../../../FormLegacy/FormFieldsV2/CheckboxField'
import Tooltip from '../Tooltip'

const CheckboxInput = ({ columnSize, name, label, value, setFieldValue, tooltip, helperText }) => {
  return (
    <div className={`column is-${columnSize} event-form-checkbox-input`}>
      <div className="event-form-input-row-flex-container">
        <CheckboxField
          name={name}
          label={label}
          onChange={(e) => setFieldValue(name, e.target.checked)}
          value={value}
        />
        {tooltip && <Tooltip name={name} tooltip={tooltip} />}
      </div>
      <p className="event-form-input-helper-text">{helperText}</p>
    </div>
  )
}

CheckboxInput.propTypes = {
  columnSize: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.bool,
  setFieldValue: PropTypes.func.isRequired,
  tooltip: PropTypes.node,
  helperText: PropTypes.string,
}

export default CheckboxInput
